import React from "react";
import { PanelEditEmployee } from "../../../UI/Employees/Edit/PanelEditEmployee";

const EditEmployee = () => {
  return (
    <div>
      <PanelEditEmployee />
    </div>
  );
};

export default React.memo(EditEmployee);

